// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__7oYOF","isPage":"Loading_isPage__hl+2o"};